import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const Popup = () => {
  const dispatch = useDispatch();
  const product = useSelector((state) => state.productDetail);
  useEffect(() => {
    const fade = setTimeout(() => {
      dispatch({
        type: "SET_CANVAS",
        payload: { openCanvas: false, message: "" },
      });
      dispatch({ type: "SET_MESSAGE", payload: "" });
    }, 1000);

    return () => clearTimeout(fade);
  }, [product.message, dispatch]);

  if (!product.canvas) return null;
  return (
    <div className="popup_container">
      <div className="popup_message">
        <p>
          {product.loadingMessage !== null
            ? product.loadingMessage
            : product.message}
        </p>
      </div>
    </div>
  );
};

export default Popup;
